import {createStore, applyMiddleware, compose, combineReducers} from 'redux';
import devTools from 'remote-redux-devtools';

import {historyListener} from './historyListener';

import {loggerMiddleware} from './middleware/logger';
import {analyticsMiddleware} from './middleware/analytics';

import {routeStateReducer} from './route/routeStateReducer'
import {imageStateReducer} from './images/imageStateReducer'

const state = {
  store: null,
};

const reducers = combineReducers({
  route: routeStateReducer,
  images: imageStateReducer,
});

const composeFunctions = [];
const middleware = [
  analyticsMiddleware,
];

if (process.env.NODE_ENV !== 'production') {
  middleware.push(loggerMiddleware);
  composeFunctions.push(window.devToolsExtension ? window.devToolsExtension() : devTools());
}

function configureStore(initialState = {}) {
  const finalCreate = compose(
    applyMiddleware(...middleware),
    ...composeFunctions
  )(createStore);

  return finalCreate(reducers, initialState);
}

export function init(initialState = {}) {
  state.store = configureStore(initialState);

  historyListener(state.store);

  return state.store;
}

export default state;



// WEBPACK FOOTER //
// ./src/state/configureStore.js